module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auto"
  }, [_c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("异地接单打印")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("YI DI JIE DAN DA YIN")]), _vm._v(" "), _c('div', {
    staticClass: "labels"
  }, [_c('div', {
    staticClass: "label-item"
  }, [_vm._v("1、智慧云端，只要有电源有网络就可使用。")]), _vm._v(" "), _c('div', {
    staticClass: "label-item"
  }, [_vm._v("2、无需复杂配置，打印不受距离和场所限制。")]), _vm._v(" "), _c('div', {
    staticClass: "label-item"
  }, [_vm._v("3、云打印可使用在餐饮外卖以外领域，如鲜花、商超、医疗、零售等场景，匹配更广泛的市场需求。")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/cloud.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6e8af28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homePage0.vue
// module id = 352
// module chunks = 1